import tableRenderer from "./tableRender"
import defaultRenderer from "./defaultRender"
let renderers = {
    table:tableRenderer,
    default:defaultRenderer
}
export const groupRenderRegister= function(name,renderer){
    renderers[name] = renderer
}
export default renderers


// WEBPACK FOOTER //
// ./src/assets/tflow/render/group/index.js